// Aligns with plant sun_needs in ScanConfirmScreen / PlantFormScreen.
export const GARDEN_SUN_EXPOSURE_OPTIONS = [
  'full sun',
  'part sun',
  'part shade',
  'full shade',
];

/** Router `location.state` key for the identification photo file when opening new-plant form. */
export const GARDEN_IDENTIFY_PHOTO_STATE_KEY = 'gardenIdentifyPhotoFile';

/**
 * Deferred features: intended homes (not AI Help–only) when implemented.
 * Bloom calendar: structured calendar UI + plant bloom data.
 * Garden book: server PDF export from Settings and/or Journal.
 */
export const FUTURE_GARDEN_ROUTE_PLAN = {
  bloomCalendar: {
    suggestedPath: '/garden/insights/bloom',
    description:
      'Weekly bloom calendar; own screen under garden shell (e.g. Insights), optional AI for sparse bloom fields.',
  },
  gardenBookPdf: {
    suggestedPath: '/garden/settings/export-book',
    alternatePath: '/garden/journal/export-book',
    description:
      'PDF of plants, seasons, notes; export action from Settings or Journal, server-side generation.',
  },
};
